<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-xl-12">
                <div class="left-card m-b-30">
                    <div class="Customer-card-body">
                        <div v-if="regMsgTextErr != ''">
                            <div class="alert-message md-form">
                                <div class="alert alert-danger">{{ regMsgTextErr }}</div>
                            </div>
                        </div>
                        <div v-if="regMsgTextSucc != ''">
                            <div class="alert-message md-form">
                                <div class="alert alert-success">{{ regMsgTextSucc }}</div>
                            </div>
                        </div>
                        <div class="card" v-if="currStep == 1">
                            <div class="card-heading">
                                <h5>{{ $t('register.user_information') }}</h5>
                            </div>
                            <div class="card-body md-form">
                                <div class="form-group">
                                    <label>{{ $t('register.first_name') }}<span class="text-red">*</span></label>
                                    <input type="text" class="form-control" v-model="firstName">
                                    <small v-if="formErrors.firstName" class="text-danger">{{ formErrors.firstName
                                        }}</small>
                                </div>
                                <div class="form-group">
                                    <label>{{ $t('register.last_name') }}<span class="text-red">*</span></label>
                                    <input type="text" class="form-control" v-model="lastName">
                                    <small v-if="formErrors.lastName" class="text-danger">{{ formErrors.lastName
                                        }}</small>
                                </div>
                                <div class="form-group">
                                    <label>{{ $t('register.date_of_birth') }}<span class="text-red">*</span></label>
                                    <input type="date" class="form-control" v-model="dob">
                                    <small v-if="formErrors.dob" class="text-danger">{{ formErrors.dob }}</small>
                                </div>
                                <div class="form-group">
                                    <label for="country" class="form-label">{{ $t('form_labels.country') }}<span
                                            class="text-red">*</span></label>
                                    <select id="country" name="country" v-model="country" class="form-control">
                                        <option value="" disabled>{{ $t('common.select_option') }}</option>
                                        <option v-for="country in countries" :key="country.id" :value="country.iso">
                                            {{ country.name }}
                                        </option>
                                    </select>
                                    <small v-if="formErrors.country" class="text-danger">{{ formErrors.country
                                        }}</small>
                                </div>
                                <div class="form-group">
                                    <label>{{ $t('form_labels.city') }}<span class="text-red">*</span></label>
                                    <input type="text" class="form-control" v-model="city">
                                    <small v-if="formErrors.city" class="text-danger">{{ formErrors.city }}</small>
                                </div>
                                <div class="form-group" v-if="country == 'US'">
                                    <label>{{ $t('form_labels.state') }}<span class="text-red">*</span></label>
                                    <input type="text" class="form-control" v-model="state">
                                    <small v-if="formErrors.state" class="text-danger">{{ formErrors.state }}</small>
                                </div>
                                <div class="form-group">
                                    <label>{{ $t('register.street_address') }}<span class="text-red">*</span></label>
                                    <input type="text" class="form-control" v-model="streetAddress">
                                    <small v-if="formErrors.streetAddress" class="text-danger">{{
                                        formErrors.streetAddress }}</small>
                                </div>
                                <div class="form-group">
                                    <label>{{ $t('form_labels.postal_code') }}<span class="text-red">*</span></label>
                                    <input type="text" class="form-control" v-model="postalCode">
                                    <small v-if="formErrors.postalCode" class="text-danger">{{ formErrors.postalCode
                                        }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="card second-step" v-if="currStep == 2">
                            <div class="card-heading">
                                <h5>{{ $t('bank.bank_information') }}</h5>
                            </div>
                            <div class="card-body md-form">
                                <div class="form-group">
                                    <label>{{ $t('bank.account_holder_name') }}<span class="text-red">*</span></label>
                                    <input type="text" class="form-control mb-1" v-model="accountHolderName">
                                    <small v-if="formErrors.accountHolderName" class="text-danger">{{
                                        formErrors.accountHolderName }}</small>
                                </div>
                                <div class="form-group" v-if="country == 'US'">
                                    <label>{{ $t('bank.routing_number') }}<span class="text-red">*</span></label>
                                    <input type="number" class="form-control" v-model="routingNumber">
                                    <small v-if="formErrors.routingNumber" class="text-danger">{{
                                        formErrors.routingNumber }}</small>
                                </div>
                                <div class="form-group">
                                    <label>{{ $t('bank.account_number') }}<span class="text-red">*</span></label>
                                    <input type="text" class="form-control" v-model="accountNumber">
                                    <small v-if="formErrors.accountNumber" class="text-danger">{{
                                        formErrors.accountNumber }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="currStep == 3">
                            <div class="card-heading">
                                <h5>{{ $t('profile.identity_verification') }}</h5>
                            </div>
                            <div class="card-body md-form step-five">
                                <div class="form-group">
                                    <label for="images">{{ $t('profile.upload_front_id') }}:</label>
                                    <input type="file" id="frontID" @change="previewImage" accept="image/*">

                                    <div v-if="idImageFront" class="images-listing">
                                        <!-- <img v-if="imagePreview.path" :src="imagePreview.path" alt="Preview">
                                        <img v-else :src="imagePreview" alt="Preview"> -->
                                        <div class="images-card">
                                            <img :src="idImageFront" :alt="$t('profile.front_id')">
                                            <button type="button" class="btn btn-primary"
                                                @click="removeImage('frontID')">
                                                <i class="fas fa-times"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="currStep == 4">
                            <div class="card-heading">
                                <h5>{{ $t('profile.identity_verification') }}</h5>
                            </div>
                            <div class="card-body md-form step-five">
                                <div class="form-group">
                                    <label for="images">{{ $t('profile.upload_back_id') }}:</label>
                                    <input type="file" id="backID" @change="previewImage" accept="image/*">

                                    <div v-if="idImageBack" class="images-listing">
                                        <div class="images-card">
                                            <img :src="idImageBack" :alt="$t('profile.back_id')">
                                            <button type="button" class="btn btn-primary"
                                                @click="removeImage('backID')">
                                                <i class="fas fa-times"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card laststep" v-if="currStep == 5">
                            <div class="card-heading">
                                <h5>{{ $t('property_detail.all_done') }}!</h5>
                            </div>
                            <div class="md-form my-5">
                                <button v-if="isLoading == true" type="button" class="btn btn-primary" @click="submit()"
                                    style="margin-left: 43% !important; height: 46px; min-width: 110px; 
                                            display: flex; justify-content: center;" disabled>
                                    <img src="https://www.vanovy.com/public/images/loader.gif"
                                        style="height: 20px;">
                                </button>
                                <button v-else type="button" class="btn btn-primary" @click="submit()">
                                    <span>{{ $t('common.submit') }}</span>
                                </button>
                            </div>
                            <div class="md-form">
                                <p><strong>{{ $t('profile.commission_note') }}:</strong> <strong>6% {{ $t('profile.commission') }}</strong> {{ $t('profile.commission_note_part2') }}
                                    {{ $t('profile.commission_note_part3') }}</p>
                            </div>
                        </div>
                        <div class="card-btn" v-if="currStep < 6">
                            <div class="footer-buttons md-form">
                                <button id="bckBtn" name="bckBtn" class="btn btn-default pull-left" v-if="currStep > 1"
                                    @click="bckBtn" :disabled="regBusy">
                                    <i class="fa fa-angle-left"></i> <span>{{ $t('register.back') }}</span>
                                </button>
                                <div>
                                    <button class="btn btn-danger mr-2" @click="cancelProcess">
                                        {{ $t('sweetalert.cancel') }}
                                    </button>
                                    <button id="regSub" name="regSub" class="btn btn-primary" @click="regSub"
                                        :disabled="regBusy" v-if="currStep !== 5">{{ regBtnText }}</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '../api'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import { validationMixin } from "vuelidate";
import postalCodes from 'postal-codes-js'
import iban from 'iban';
import { validateRoutingNumber } from 'bank-routing-number-validator';


const options = {
    toast: {
        position: SnotifyPosition.rightTop,
    }
}
Vue.use(Snotify, options)
export default {
    mixins: [validationMixin],

    data() {
        return {
            currStep: 1,
            regBtnText: this.$t('register.next'),
            regMsgTextErr: '',
            regMsgTextSucc: '',
            region: '',
            firstName: '',
            lastName: '',
            dob: new Date(),
            streetAddress: '',
            city: '',
            state: '',
            country: '',
            postalCode: '',
            accountHolderName: '',
            routingNumber: null,
            accountNumber: '',
            idImageFront: '',
            idImageBack: '',
            countries: [],
            postalCodeRegex: null,
            isLoading: false,
            formErrors: {
                firstName: '',
                lastName: '',
                dob: '',
                country: '',
                city: '',
                state: '',
                streetAddress: '',
                postalCode: '',
                accountHolderName: '',
                routingNumber: '',
                accountNumber: ''
            },
        };
    },

    mounted() {
        API.getAllCountries(data => {
            this.countries = data.data;
        }, error => {
            console.log(error);
        });
        this.region = localStorage.getItem('region');
    },

    methods: {
        cancelProcess() {
            if (this.$route.query.from === 'booking_requests') {
                this.$router.push({ path: '/booking_requests' });
            } else if (this.$route.query.from === 'custom_offers') {
                this.$router.push({ path: '/custom_offers' });
            } else if (this.$route.query.from === 'dashboard') {
                this.$router.push({ path: '/dashboard' });
            } else {
                this.$router.push({ name: 'home' });
            }
        },
        previewImage(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    if (event.target.id == 'frontID') {
                        this.idImageFront = e.target.result;
                    }
                    if (event.target.id == 'backID') {
                        this.idImageBack = e.target.result;
                    }
                };
                reader.readAsDataURL(file);
            }
        },
        removeImage(side) {
            if (side == 'frontID') {
                this.idImageFront = null;
            }
            if (side == 'backID') {
                this.idImageBack = null;
            }
        },
        bckBtn() {
            if (this.currStep > 1) {
                this.regMsgTextErr = '';
                this.regBtnText = this.$t('register.next');
                this.currStep = this.currStep - 1;
            }
        },
        submit() {
            this.isLoading = true;

            const formData = new FormData();
            formData.append('first_name', this.firstName);
            formData.append('last_name', this.lastName);
            formData.append('dob', this.dob);
            formData.append('street_address', this.streetAddress);
            formData.append('city', this.city);
            formData.append('state', this.state);
            formData.append('country', this.country);
            formData.append('postal_code', this.postalCode);
            formData.append('ac_holder_name', this.accountHolderName);
            formData.append('account_number', this.accountNumber);
            if (this.country === 'US') {
                formData.append('routing_number', this.routingNumber);
            }
            formData.append('id_front', this.idImageFront); // base64
            formData.append('id_back', this.idImageBack);   // base64
            API.addBankinfo(formData, data => {
                this.isLoading = false;
                    
                // Store the user object
                localStorage.setItem('user', JSON.stringify(data.user));

                // Extract permissions
                if (data.user.permissions && Array.isArray(data.user.permissions)) {
                    // Map only the permission names (or IDs if you want)
                    const userPermissions = data.user.permissions.map(p => p.name); 
                    localStorage.setItem('userPermissions', JSON.stringify(userPermissions));
                } else {
                    localStorage.removeItem('userPermissions');
                }

                // Store roles if they exist
                if (data.user.roles && Array.isArray(data.user.roles)) {
                    localStorage.setItem('userRoles', JSON.stringify(data.user.roles));
                } else {
                    localStorage.removeItem('userRoles');
                }
                    
                    // this.showAfterLogin = true;
                    // this.showBeforeLogin = false;

                localStorage.setItem('stripeVerified', 'false');
                if (this.$route.query.from === 'booking_requests') {
                    this.$router.push({ path: '/booking_requests', query: { stripe_pending: '1' } });
                } else if (this.$route.query.from === 'custom_offers') {
                    this.$router.push({ path: '/custom_offers', query: { stripe_pending: '1' } });
                } else if (this.$route.query.from === 'dashboard') {
                    this.$router.push({ path: '/dashboard', query: { stripe_pending: '1' } });
                } else {
                    this.$router.push({ name: 'home' });
                }
            }, error => {
                this.isLoading = false;
                this.regMsgTextErr = error.error;
            });
        },
        regSub() {
            this.regMsgTextErr = '';
            this.formErrors = {
                firstName: '',
                lastName: '',
                dob: '',
                country: '',
                streetAddress: '',
                city: '',
                state: '',
                postalCode: '',
                accountHolderName: '',
                routingNumber: '',
                accountNumber: ''
            };

            if (this.currStep === 1) {
                let valid = true;

                if (!this.firstName.trim()) {
                    this.formErrors.firstName = this.$t('error_messages.required_field');
                    valid = false;
                }

                if (!this.lastName.trim()) {
                    this.formErrors.lastName = this.$t('error_messages.required_field');
                    valid = false;
                }

                if (!this.dob || !this.dob.toString().trim()) {
                    this.formErrors.dob = this.$t('error_messages.required_field');
                    valid = false;
                } else {
                    const dobDate = new Date(this.dob);
                    const today = new Date();
                    dobDate.setHours(0, 0, 0, 0);
                    today.setHours(0, 0, 0, 0);
                    if (isNaN(dobDate.getTime())) {
                        this.formErrors.dob = this.$t('error_messages.invalid_dob');
                        valid = false;
                    } else if (dobDate >= today) {
                        this.formErrors.dob = this.$t('error_messages.dob_past');
                        valid = false;
                    }
                }

                if (!this.country) {
                    this.formErrors.country = this.$t('error_messages.required_field');
                    valid = false;
                }

                if (!this.streetAddress.trim()) {
                    this.formErrors.streetAddress = this.$t('error_messages.required_field');
                    valid = false;
                }

                if (!this.city.trim()) {
                    this.formErrors.city = this.$t('error_messages.required_field');
                    valid = false;
                }

                if (this.country === 'US' && (!this.state || !this.state.trim())) {
                    this.formErrors.state = this.$t('error_messages.required_field');
                    valid = false;
                }

                if (!this.postalCode.trim()) {
                    this.formErrors.postalCode = this.$t('error_messages.required_field');
                    valid = false;
                } else {
                    const verifyPostalCode = postalCodes.validate(this.country, this.postalCode);
                    if (verifyPostalCode !== true) {
                        this.formErrors.postalCode = verifyPostalCode;
                        valid = false;
                    }
                }

                if (!valid) return;

                this.currStep = 2;
                this.regBtnText = this.$t('register.next');
            }

            else if (this.currStep === 2) {
                let valid = true;

                if (!this.accountHolderName || !this.accountHolderName.trim()) {
                    this.formErrors.accountHolderName = this.$t('error_messages.required_field');
                    valid = false;
                }

                if (this.country === 'US') {
                    if (!this.routingNumber) {
                        this.formErrors.routingNumber = this.$t('error_messages.required_field');
                        valid = false;
                    } else if (!validateRoutingNumber(this.routingNumber)) {
                        this.formErrors.routingNumber = this.$t('validations.invalid_routing_number');
                        valid = false;
                    }
                }

                if (!this.accountNumber || !this.accountNumber.trim()) {
                    this.formErrors.accountNumber =this.$t('error_messages.required_field');
                    valid = false;
                } else if (!iban.isValid(this.accountNumber)) {
                    this.formErrors.accountNumber = this.$t('validations.invalid_account_number');
                    valid = false;
                }

                if (!valid) return;

                this.currStep = 3;
                this.regBtnText = this.$t('register.next');
            }

            else if (this.currStep === 3) {
                this.currStep = 4;
                this.regBtnText = this.$t('register.next');
            }

            else if (this.currStep === 4) {
                this.currStep = 5;
                this.regBtnText = this.$t('register.next');
            }

            else if (this.currStep === 5) {
                this.submit();
            }
        },
    }
}
</script>

<style>
.checkbox-group .custom-control-label {
    padding-top: 5px !important;
}

.custom-label {
    font-size: 0.875rem;
}

.checkbox-group .b-form-checkbox {
    display: inline-flex;
    align-items: center;
    margin-right: 10px;
    vertical-align: middle;
}

.Customer-card-body {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
}

.Customer-card-body .card {
    border: 0;
}

.Customer-card-body .card .card-heading h5 {
    margin: 0;
    font-size: 22px;
    line-height: 1.2;
}

.Customer-card-body .card-body {
    border: 0;
    border-radius: 0;
    padding: 20px;
}

.Customer-card-body .card-body .form-group .radio-buttons-wrapper {
    padding-left: 1.25rem;
    display: flex;
    flex-wrap: wrap;
}

.Customer-card-body .card .card-heading {
    margin-bottom: 0;
}

.footer-buttons.md-form {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.footer-buttons.md-form .btn.btn-default {
    border: 1px solid #B6B6B6;
    background: #B6B6B6;
    width: 105px;
    color: #fff;
    margin-right: 15px;
    font-weight: 500;
    border-radius: 5px;
    height: 44px;
}

.footer-buttons.md-form .btn.btn-default:hover {
    background: #70d3ff;
    border-color: #70d3ff;
    color: #fff;
}

.footer-buttons.md-form .btn.btn-primary {
    border-radius: 5px !important;
}

.Customer-card-body .card.second-step .card-body .form-group .radio-buttons-wrapper {
    padding-left: 0;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
}

.Customer-card-body .card.second-step .card-body .form-group .radio-buttons-wrapper label.form-check-label {
    margin-left: 0;
}

.form-group {
    margin-bottom: 1rem;
}

.Customer-card-body .card.second-step .card-body .form-group .radio-buttons-wrapper label.form-label {
    width: 100%;
    font-weight: 500;
}

.Customer-card-body .card.second-step .card-body .form-group .form-check {
    width: 70px;
    padding-left: 20px;
}

.Customer-card-body .card-body .form-group .form-control {
    border-radius: 35px;
}

.Customer-card-body .card-body .form-group .checkbox-group .form-check .form-check-label {
    margin: 0;
}

.Customer-card-body .card-body .form-group .checkbox-group .form-check {
    padding-left: 20px;
}

.Customer-card-body .card-body .form-group .checkbox-group .custom-label {
    font-weight: 500;
}

.Customer-card-body .card-body.step-five .form-group label {
    display: block;
    font-weight: 500;
    margin-bottom: 10px;
}

.Customer-card-body .card-body.step-five .form-group {
    margin: 0;
}

.images-listing {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
}

.Customer-card-body .card-body.step-five .form-group input[type=file] {
    font-size: 14px;
}

.Customer-card-body .card-body.step-five .form-group input[type=file]::file-selector-button {
    margin-right: 20px;
    border: none;
    background: #70d3ff;
    padding: 10px 20px;
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
    transition: background .2s ease-in-out;
}

.Customer-card-body .card.laststep {
    border: 1px solid #bcbcbf;
    border-radius: 10px;
    padding: 30px 20px;
    text-align: center;
}

.Customer-card-body .card-body .form-group label {
    font-weight: 500;
}

.guest-content {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    border-right: 0 !important;
}

.guest-content:last-child {
    margin-bottom: 0;
}

.guest-content .form-control {
    padding: 0;
    height: 30px;
    border: 0;
    text-align: center;
    width: 60px;
    appearance: none;
}

.guest-content .form-control::-webkit-outer-spin-button,
.guest-content .form-control::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.form-group.quality-fileds {
    display: flex;
    align-items: center;
    gap: 25px;
}

.form-group.quality-fileds .guest-content {
    margin: 0;
    gap: 10px;
}

.form-group.quality-fileds .guest-content .input-group {
    gap: 3px;
}

.form-group.quality-fileds .guest-content label {
    margin: 00;
}

@media (max-width: 574.98px) {
    .Customer-card-body .card .card-heading h5 {
        font-size: 18px;
    }
}
</style>
